import { render, staticRenderFns } from "./ColorCircle.vue?vue&type=template&id=7642de20&scoped=true&"
import script from "./ColorCircle.vue?vue&type=script&lang=js&"
export * from "./ColorCircle.vue?vue&type=script&lang=js&"
import style0 from "./ColorCircle.vue?vue&type=style&index=0&id=7642de20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7642de20",
  null
  
)

export default component.exports